
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_1pq3r_10",
  "with-toolbar": "awsui_with-toolbar_l0dv0_1pq3r_44",
  "header": "awsui_header_l0dv0_1pq3r_48",
  "list--with-icons": "awsui_list--with-icons_l0dv0_1pq3r_61",
  "header-link": "awsui_header-link_l0dv0_1pq3r_65",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1pq3r_76",
  "header-link-text": "awsui_header-link-text_l0dv0_1pq3r_76",
  "header-logo": "awsui_header-logo_l0dv0_1pq3r_81",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1pq3r_87",
  "items-control": "awsui_items-control_l0dv0_1pq3r_92",
  "list-container": "awsui_list-container_l0dv0_1pq3r_97",
  "divider-header": "awsui_divider-header_l0dv0_1pq3r_105",
  "root--collapsed": "awsui_root--collapsed_l0dv0_1pq3r_109",
  "list": "awsui_list_l0dv0_1pq3r_61",
  "list-variant-root": "awsui_list-variant-root_l0dv0_1pq3r_122",
  "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_1pq3r_129",
  "list-variant-root--collapsed": "awsui_list-variant-root--collapsed_l0dv0_1pq3r_132",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1pq3r_139",
  "list-variant-expandable-link-group--collapsed": "awsui_list-variant-expandable-link-group--collapsed_l0dv0_1pq3r_145",
  "list-variant-section": "awsui_list-variant-section_l0dv0_1pq3r_149",
  "list-variant-section--collapsed": "awsui_list-variant-section--collapsed_l0dv0_1pq3r_152",
  "list-variant-link-group": "awsui_list-variant-link-group_l0dv0_1pq3r_161",
  "list-variant-link-group--collapsed": "awsui_list-variant-link-group--collapsed_l0dv0_1pq3r_177",
  "link-group-children": "awsui_link-group-children_l0dv0_1pq3r_194",
  "link-group-children--collapsed": "awsui_link-group-children--collapsed_l0dv0_1pq3r_211",
  "link-group-children-inner": "awsui_link-group-children-inner_l0dv0_1pq3r_228",
  "link-group-children-inner--expanded": "awsui_link-group-children-inner--expanded_l0dv0_1pq3r_247",
  "link-group-children-inner--settled": "awsui_link-group-children-inner--settled_l0dv0_1pq3r_263",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_1pq3r_267",
  "list-variant-section-group--collapsed": "awsui_list-variant-section-group--collapsed_l0dv0_1pq3r_273",
  "list-item": "awsui_list-item_l0dv0_1pq3r_277",
  "list-item--collapsed": "awsui_list-item--collapsed_l0dv0_1pq3r_290",
  "list-item--link-with-info": "awsui_list-item--link-with-info_l0dv0_1pq3r_296",
  "list-item--group": "awsui_list-item--group_l0dv0_1pq3r_301",
  "section": "awsui_section_l0dv0_1pq3r_301",
  "section-group": "awsui_section-group_l0dv0_1pq3r_302",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_1pq3r_307",
  "section--no-ident": "awsui_section--no-ident_l0dv0_1pq3r_310",
  "section--expand-icon-end": "awsui_section--expand-icon-end_l0dv0_1pq3r_310",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_1pq3r_311",
  "expandable-link-group--expand-icon-end": "awsui_expandable-link-group--expand-icon-end_l0dv0_1pq3r_312",
  "section--collapsed": "awsui_section--collapsed_l0dv0_1pq3r_315",
  "expandable-link-group--collapsed": "awsui_expandable-link-group--collapsed_l0dv0_1pq3r_316",
  "expandable-link-group--active": "awsui_expandable-link-group--active_l0dv0_1pq3r_340",
  "item-icon": "awsui_item-icon_l0dv0_1pq3r_344",
  "refresh": "awsui_refresh_l0dv0_1pq3r_387",
  "section-header": "awsui_section-header_l0dv0_1pq3r_438",
  "section-group-title": "awsui_section-group-title_l0dv0_1pq3r_453",
  "section-group-title--collapsed": "awsui_section-group-title--collapsed_l0dv0_1pq3r_474",
  "link": "awsui_link_l0dv0_1pq3r_194",
  "link-active": "awsui_link-active_l0dv0_1pq3r_532",
  "link--collapsed": "awsui_link--collapsed_l0dv0_1pq3r_539",
  "header-link-active": "awsui_header-link-active_l0dv0_1pq3r_659",
  "link-text-wrapper-content": "awsui_link-text-wrapper-content_l0dv0_1pq3r_688",
  "link-text-wrapper": "awsui_link-text-wrapper_l0dv0_1pq3r_688",
  "link-text-wrapper--collapsed": "awsui_link-text-wrapper--collapsed_l0dv0_1pq3r_715",
  "label-text": "awsui_label-text_l0dv0_1pq3r_737",
  "label-text--collapsed": "awsui_label-text--collapsed_l0dv0_1pq3r_757",
  "info": "awsui_info_l0dv0_1pq3r_776",
  "item-icon--collapsed": "awsui_item-icon--collapsed_l0dv0_1pq3r_798",
  "external-icon": "awsui_external-icon_l0dv0_1pq3r_802",
  "divider": "awsui_divider_l0dv0_1pq3r_105",
  "divider-default": "awsui_divider-default_l0dv0_1pq3r_810",
  "divider--collapsed": "awsui_divider--collapsed_l0dv0_1pq3r_814",
  "section--expand-icon-end-with-info": "awsui_section--expand-icon-end-with-info_l0dv0_1pq3r_844"
};
  